
export default function Header() {
  return (
    <header className="bg-white shadow-lg border-b border-gray-200">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
              <i className="ri-presentation-line text-white text-xl"></i>
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">外贸财税合规解决方案</h1>
              <p className="text-sm text-gray-600">专业 · 合规 · 高效</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-6">
            <nav className="hidden md:flex items-center space-x-6">
              <a href="#solutions" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">解决方案</a>
              <a href="#cases" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">案例分析</a>
              <a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">联系我们</a>
            </nav>
            
            <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line mr-2"></i>
              立即咨询
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
